import dayjs from 'dayjs'

import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const SectionWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
`
const Text = styled.div`
  font-size: 13px;
  font-weight: 600;
`
const SectionLine = styled.div`
  position: absolute;
  top: 50%;
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.secondaryBackground};
`

const SectionTextWrapper = styled.div`
  display: flex;
  align-items: center;
  z-index: 1;
  padding: 0 20px;
  background-color: ${({ theme }) => theme.quinaryBackground};
`

export function Section({ day }: { day?: number }): React.ReactNode {
  const { t } = useTranslation()

  return (
    <SectionWrapper>
      <SectionLine />
      <SectionTextWrapper>
        <Text>{day === dayjs().startOf('day').valueOf() ? t('dateFormats.today') : dayjs(day).format('LL')}</Text>
      </SectionTextWrapper>
    </SectionWrapper>
  )
}
